(function($) { 
    $(".like-btn").on("click", function(e){
        var $btn = $(this);
        e.preventDefault();
        $btn.prop("disabled", true);
        $.ajax({
            url: valtiolla.ajaxurl,
            method: 'post',
            dataType: "json",
            data:{
                action: 'valtiolla_update_like',
                post_id: $btn.data("postid"),
                nonce: $btn.data("nonce")
            },
            success: function(data){
                if (data.v == 1){
                    $btn.html(data.likes);
                }
            },
            error: function(){
                $btn.prop("disabled", false);
            }
        })
    })

})( jQuery );